import type { DataSourceEntity } from '@unifyapps/defs/types/dataSource';
import { UAEntityTypes } from '@unifyapps/defs/types/entities';
import type { InterfaceNamespaceEntity } from '@unifyapps/defs/types/namespace';
import {
  type InterfacePageEntity,
  InterfacePageEntityComponentType,
} from '@unifyapps/defs/types/page';
import _keyBy from 'lodash/keyBy';
import type { InterfaceComponent } from '../../../../../../types/interfaceComponent';

type ComponentData = InterfacePageEntity | DataSourceEntity | InterfaceNamespaceEntity;

export function getAuthInterfaceComponentSlug(
  interfaceComponent: InterfaceComponent,
  customPublicPages?: string[],
): string {
  return interfaceComponent.type === InterfacePageEntityComponentType.PAGE &&
    !customPublicPages?.includes(interfaceComponent.id ?? '')
    ? interfaceComponent.slug
    : (interfaceComponent.id ?? '');
}

export function processAuthComponentData(
  componentData: ComponentData[] | undefined,
  interfaceComponent: InterfaceComponent,
  locale: string,
) {
  const fetchedComponent = componentData?.find((component) => {
    // id is added for module, slug is added for page
    if (interfaceComponent.type === InterfacePageEntityComponentType.PAGE) {
      // drawer/modal nested pages key the lookup by the page entity id (from block content) while
      // root pages key by the URL slug; the backend resolves both, so match against either here
      return (
        component.properties.slug === interfaceComponent.slug ||
        component.id === interfaceComponent.slug
      );
    }
    if (interfaceComponent.type === InterfacePageEntityComponentType.MODULE) {
      return component.id === interfaceComponent.id;
    }
    return false;
  }) as InterfacePageEntity | undefined;

  const fetchedDataSources = componentData?.filter(
    (component) => component.entityType === (UAEntityTypes.DeployedDataSource as string),
  ) as DataSourceEntity[] | undefined;

  const interfacePageNamespace = componentData?.find((entity) => {
    return (
      entity.entityType === UAEntityTypes.DeployedInterfaceNamespace &&
      entity.properties.locale === locale
    );
  }) as InterfaceNamespaceEntity | undefined;

  const dataSourcesMap = fetchedDataSources ? _keyBy(fetchedDataSources, 'id') : undefined;

  return {
    fetchedComponent,
    fetchedDataSources,
    interfacePageNamespace,
    dataSourcesMap,
  };
}
